module.exports = __webpack_public_path__ + "assets/img/mecha-btn-ef01b4f5.png";